import { ProductsList } from '../../../components/shared/products/ProductsList'
import { Product } from '@cabukaka/types'
import { Package } from 'lucide-react'

interface CategoryProductsProps {
    products: Product[]
}

export default function CategoryProducts({ products }: CategoryProductsProps) {
    return (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
            {products.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-24 text-center">
                    <div className="relative mb-8">
                        <div className="w-24 h-24 bg-orange-50 rounded-full flex items-center justify-center">
                            <Package className="w-10 h-10 text-orange-300" />
                        </div>
                        <div className="absolute -top-1 -right-1 w-6 h-6 bg-orange-400 rounded-full flex items-center justify-center text-white text-xs font-bold">
                            0
                        </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                        Aucun produit pour l'instant
                    </h3>
                    <p className="text-gray-400 text-sm max-w-xs leading-relaxed">
                        Cette catégorie ne contient pas encore de produits. Revenez bientôt, de nouvelles références arrivent régulièrement !
                    </p>
                </div>
            ) : (
                <ProductsList
                    products={products}
                    layout="grid"
                    columns={{ mobile: 1, tablet: 4, desktop: 4 }}
                />
            )}
        </div>
    )
}
